import { defineComponent as C, reactive as T, onMounted as w, computed as D, watch as u, createElementBlock as i, openBlock as n, normalizeClass as d, withDirectives as y, createElementVNode as r, vModelText as L, vShow as k, renderSlot as o, Fragment as b, renderList as f, createBlock as m, withCtx as B, createCommentVNode as _, toDisplayString as v } from "vue";
import { _ as I } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import { _ as N } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
const x = {
  key: 1,
  class: "arbo-label--text"
}, E = { class: "arbo-tabs__content" }, M = { class: "arbo-tab__body" }, j = /* @__PURE__ */ C({
  __name: "Tabs",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    keyLabel: {
      type: String,
      default: "name"
    },
    keyContent: {
      type: String,
      default: "content"
    },
    keyValue: {
      type: String,
      default: "id"
    },
    keyTooltip: {
      type: String,
      default: "tooltipName"
    },
    keyIcon: {
      type: String,
      default: "icon"
    },
    keyDisable: {
      type: String,
      default: "disable"
    },
    position: {
      type: String,
      default: "top"
    },
    value: {
      type: [String, Number, Boolean],
      default: ""
    }
  },
  emits: ["input"],
  setup(g, { emit: h }) {
    const e = g, s = T({
      selected: ""
    }), V = h, p = () => {
      if (s.selected === "" && e.value === "") {
        const t = e.tabs.find((a) => !a[e.keyDisable]);
        t ? s.selected = t[e.keyValue] : e.tabs.length > 0 && (s.selected = e.tabs[0][e.keyValue]);
      } else
        s.selected = e.value;
    };
    w(() => {
      p();
    });
    function $(t) {
      t[e.keyDisable] || (s.selected = t[e.keyValue]);
    }
    const S = D(() => {
      let t = "top";
      switch (e.position) {
        case "left":
          t = "right";
          break;
        case "right":
          t = "left";
          break;
        default:
          t = "top";
      }
      return t;
    });
    return u(
      () => s.selected,
      (t) => {
        V("input", t);
      }
    ), u(
      () => e.value,
      (t, a) => {
        p();
      }
    ), (t, a) => (n(), i("div", {
      class: d(["arbo-tabs", e.position])
    }, [
      y(r("input", {
        "onUpdate:modelValue": a[0] || (a[0] = (l) => s.selected = l)
      }, null, 512), [
        [L, s.selected],
        [k, !1]
      ]),
      r("div", {
        class: d(["arbo-tabs__label", e.position])
      }, [
        o(t.$slots, "label_prepend"),
        (n(!0), i(b, null, f(e.tabs, (l, c) => (n(), m(N, {
          class: d(["arbo-label", [{ selected: s.selected === l[e.keyValue], disable: l[e.keyDisable], "has-text": l[e.keyLabel], "has-icon": l[e.keyIcon] }, `${e.position}`]]),
          key: c,
          onClick: (z) => $(l),
          content: l[e.keyTooltip],
          delay: [300, 0],
          placement: S.value
        }, {
          default: B(() => [
            o(t.$slots, `label_${l[e.keyValue]}`, { tab: l }, () => [
              l[e.keyIcon] ? (n(), m(I, {
                key: 0,
                class: "arbo-label__icon",
                label: "",
                type: "tertiary",
                "prefix-icon": l[e.keyIcon]
              }, null, 8, ["prefix-icon"])) : _("", !0),
              l[e.keyLabel] ? (n(), i("div", x, v(l[e.keyLabel]), 1)) : _("", !0)
            ])
          ]),
          _: 2
        }, 1032, ["class", "onClick", "content", "placement"]))), 128)),
        o(t.$slots, "label_append")
      ], 2),
      r("div", E, [
        o(t.$slots, "content_prepend"),
        (n(!0), i(b, null, f(e.tabs, (l, c) => y((n(), i("div", {
          class: "arbo-tab",
          key: c
        }, [
          o(t.$slots, `${l[e.keyValue]}`, { tab: l }, () => [
            r("div", M, v(l[e.keyContent]), 1)
          ])
        ])), [
          [k, s.selected === l[e.keyValue]]
        ])), 128)),
        o(t.$slots, "content_append")
      ])
    ], 2));
  }
});
export {
  j as _
};
